import React from 'react'
import { Switch } from 'material-ui';

function FormSwitch(props) {
    const { input, disabled } = props;
    return <Switch disabled={ disabled } checked={ input.value } onChange = { input.onChange }  />
}

export default FormSwitch